import noDataImg from "../../../../assets/images/nofilesorfolder.png";

export default function NoData({ title = "" }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] w-full text-center mx-auto">
      <img
        src={noDataImg}
        alt="No Files Found"
        className="w-64 sm:w-80 md:w-[300px] lg:w-[300px] max-w-full h-auto mx-auto"
      />
      <p className="mt-6 text-gray-600 text-base sm:text-lg md:text-xl font-medium">
        {`No ${title} Found`}
      </p>
    </div>
  );
}
